export default "__VITE_ASSET__CGFzSL6z__"